<template>
  <form-wizard
    shape="circle"
    color="#016b3a"
    :title="null"
    :subtitle="null"
    back-button-text="Voltar"
    next-button-text="Próximo"
    :finish-button-text="textoBotaoFinalizar"
    class="mb-3"
    @on-complete="verificaSalvarProposta"
  >
    <template slot="footer" slot-scope="props">
      <div class="wizard-footer mt-2">
        <b-row v-if="props.activeTabIndex == 1">
          <b-col cols="12" md="12" class="wizard-footer-right wizard-footer-col">
            <b-button variant="outline-primary" class="wizard-footer-btn" @click="calcular"> Calcular </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" :md="props.activeTabIndex == 2 ? 6 : 12" class="wizard-footer-right" v-if="!props.isLastStep">
            <wizard-button
              :disabled="!habilitarBotaoProximoCalcular(props.activeTabIndex)"
              @click.native="props.nextTab()"
              :style="props.fillButtonStyle"
              class="wizard-footer-btn"
            >
              Próximo
            </wizard-button>
          </b-col>

          <b-col :md="props.activeTabIndex == 2 ? 6 : 12" class="wizard-footer-right" cols="12" v-else>
            <b-button
              variant="primary"
              class="wizard-footer-btn"
              @click="verificaSalvarProposta"
              :style="props.fillButtonStyle"
            >
              {{
                props.isLastStep
                  ? parametro.habilitaReconhecimentoFacialOuDocumentacao
                    ? 'Solicitar Contratação'
                    : 'Enviar Solicitação '
                  : 'Próximo'
              }}
            </b-button>
          </b-col>

          <b-col v-if="props.activeTabIndex == 0" cols="12">
            <wizard-button :style="props.fillButtonStyle" @click.native="retornarAbaInicial" class="wizard-footer-btn">
              Voltar
            </wizard-button>
          </b-col>

          <b-col cols="12">
            <wizard-button
              :style="props.fillButtonStyle"
              v-if="props.activeTabIndex > 0"
              @click.native="props.prevTab()"
              class="wizard-footer-btn"
            >
              Voltar
            </wizard-button>
          </b-col>
        </b-row>
      </div>
    </template>

    <!-- Segurado -->
    <tab-content v-if="!origemAplicativo" title="Segurado" :before-change="validationDadosSegurado">
      <validation-observer ref="tomRules" tag="form">
        <!-- Consulta Segurado -->
        <b-form-group label="Segurado" label-for="segurado" v-show="campoSeguradoSelecionado">
          <validation-provider #default="{ errors }" name="Segurado" rules="required">
            <b-skeleton v-if="isBusySegurado" type="input"></b-skeleton>
            <vue-autosuggest
              v-else
              id="segurado"
              v-model="proposta.segurado"
              :suggestions="suggestions"
              :input-props="{ id: 'autosuggest__input', class: 'form-control', placeholder: 'Digite aqui o nome do segurado' }"
              @selected="getSuggestionValue"
              @input="fetchResults"
            >
              <template slot-scope="{ suggestion }">
                <div class="d-flex align-items-center">
                  <b-avatar :src="suggestion.item.tomador.foto ? suggestion.item.tomador.foto.foto : null" />
                  <div class="detail ml-50">
                    <b-card-text class="mb-0">
                      {{ suggestion.item.tomador.nomeCompleto }}
                    </b-card-text>
                    <small class="text-muted">
                      CPF: {{ suggestion.item.tomador.cpf }} - Categoria: {{ suggestion.item.situacaoPrevidenciaria }} -
                      Matrícula: {{ suggestion.item.matricula }}
                    </small>
                  </div>
                </div>
              </template>
            </vue-autosuggest>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <!-- Campos do tomador -->
        <b-row v-show="this.exibeDadosSegurado">
          <b-col md="3">
            <b-form-group label="CPF" label-for="cpf">
              <b-form-input readonly id="cpf" type="text" placeholder="CPF" v-model="segurado.tomador.cpf" />
            </b-form-group>
          </b-col>
          <b-col md="9">
            <b-form-group label="Nome Completo" label-for="nomeCompleto">
              <b-form-input
                readonly
                id="nomeCompleto"
                type="text"
                placeholder="Nome Completo"
                v-model="segurado.tomador.nomeCompleto"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-show="this.exibeDadosSegurado">
          <b-col md="3">
            <b-form-group label="Categoria" label-for="categoria">
              <b-form-input readonly id="categoria" type="text" placeholder="Categoria" v-model="segurado.categoria" />
            </b-form-group>
          </b-col>
          <b-col md="9">
            <b-form-group label="Nome Social" label-for="nomeSocial">
              <b-form-input
                readonly
                id="nomeSocial"
                type="text"
                placeholder="Nome Social"
                v-model="segurado.tomador.nomeSocial"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-show="this.exibeDadosSegurado">
          <b-col md="3">
            <b-form-group label="Data de Nascimento" label-for="dataNascimento">
              <b-form-input
                readonly
                id="dataNascimento"
                type="text"
                placeholder="Data de Nascimento"
                v-model="segurado.tomador.dataNascimento"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Remuneração" label-for="remuneracaoProventos">
              <b-form-input
                readonly
                id="remuneracaoProventos"
                type="text"
                placeholder="Remuneração"
                v-model="segurado.remuneracaoProventos"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Margem Utilizada" label-for="margemUtilizada">
              <b-form-input
                readonly
                id="margemUtilizada"
                type="text"
                placeholder="Margem Utilizada"
                v-model="segurado.margemUtilizada"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Margem Disponível" label-for="margemDisponivel">
              <b-form-input
                readonly
                id="margemDisponivel"
                type="text"
                placeholder="Margem Disponível"
                v-model="segurado.margemDisponivel"
                style="text-transform: uppercase"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <!-- Tipo de Cálculo  -->
    <tab-content title="Tipo de Cálculo" :before-change="validationTipoCalculo">
      <b-card-title v-if="origemAplicativo" title-tag="h3" class="font-weight-bold mb-2 mt-2"> Tipo de Cálculo </b-card-title>

      <validation-observer ref="tipRules" tag="form" rules="required">
        <b-row>
          <b-col :md="origemAplicativo ? 12 : 6">
            <b-form-group label="Tabela de Cálculo" v-slot="{ ariaDescribedby }">
              <validation-provider #default="{ errors }" name="Tabela de Cálculo" rules="required">
                <b-form-select
                  v-model="proposta.tipoCalculo"
                  :options="statusTipoCalculo"
                  :aria-describedby="ariaDescribedby"
                  @change="buscarTipoDeCalculo"
                  placeholder="Selecione:"
                >
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Forma de Cálculo. Por valor da parcela ou pelo valor do empréstimo -->
          <b-col :md="origemAplicativo ? 12 : 6">
            <b-form-group label="Forma de Cálculo" v-slot="{ ariaDescribedby }">
              <validation-provider #default="{ errors }" name="Forma de Cálculo" rules="required">
                <b-form-radio-group
                  id="radiosFormasDeCalculo"
                  v-model="proposta.formaCalculo"
                  :options="optionsFormaCalculo"
                  :aria-describedby="ariaDescribedby"
                  button-variant="outline-primary"
                  name="radio-btn-outline"
                  buttons
                ></b-form-radio-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col :md="origemAplicativo ? 12 : 6">
            <b-form-group label="Compra de Dívida?" v-slot="{ ariaDescribedby }">
              <validation-provider #default="{ errors }" name="Compra de Dívida?" rules="required">
                <b-form-radio-group
                  id="compraDeDivida"
                  v-model="proposta.compraDeDivida"
                  :options="[
                    { text: 'SIM', value: true },
                    { text: 'NÃO', value: false },
                  ]"
                  :aria-describedby="ariaDescribedby"
                  button-variant="outline-primary"
                  name="radio-btn-outline"
                  buttons
                ></b-form-radio-group>
                <small class="d-block text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <!-- Dados da consignação:  -->
    <tab-content title="Dados da consignação" :before-change="validationDadosConsignacao">
      <b-card-title v-if="origemAplicativo" title-tag="h3" class="font-weight-bold mb-2 mt-2">
        Dados da consignação
      </b-card-title>

      <validation-observer ref="dadosRules" tag="form">
        <b-row>
          <b-col md="4">
            <b-form-group label="Valor do Empréstimo" label-for="valor">
              <b-skeleton v-if="calculandoParcela" type="input"></b-skeleton>
              <validation-provider
                v-else
                #default="{ errors }"
                name="Valor do Empréstimo"
                :rules="{
                  required: true,
                  valor: Number(proposta.valorMaximoGeral).toFixed(2),
                  valor_minimo: formatarParaNumber(parametroValorMinimoEmprestimo),
                  zero: [],
                }"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <span class="input-group-text">R$</span>
                  </b-input-group-prepend>
                  <b-form-input
                    id="valor"
                    placeholder="Valor do Empréstimo"
                    v-model="proposta.valor"
                    v-number="number"
                    :readonly="proposta.formaCalculo == 'valorDaParcela'"
                  />
                </b-input-group>
                <small
                  class="text-primary d-block"
                  v-if="proposta.valorMaximoGeral != null || proposta.valorMaximoGeral != undefined"
                  >Valor Máx ({{ formatarValor(proposta.valorMaximoGeral) }})</small
                >
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Parcelas" label-for="parcelas">
              <validation-provider
                #default="{ errors }"
                name="Parcelas"
                :rules="{
                  required: true,
                  parcela: proposta.parcelaMaxima,
                  zero: [],
                }"
              >
                <b-form-input
                  id="parcelas"
                  placeholder="Parcelas"
                  v-model="proposta.parcelas"
                  v-on:keypress="isNumber($event)"
                  maxlength="3"
                  v-bloqueioCaractereMask="{ tamanho: 3, regex: /[^0-9]/ }"
                />
                <small class="text-primary d-block" v-if="proposta.parcelaMaxima"
                  >Parcela(s) Máx ({{ proposta.parcelaMaxima }}x)</small
                >
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="
                proposta.tipoCalculo == 'SAC'
                  ? 'Valor da 1º Parcela'
                  : proposta.tipoCalculo == 'posFixado'
                  ? 'Valor Previsto'
                  : 'Valor da Parcela'
              "
              label-for="valorPrimeiraParcela"
            >
              <b-skeleton v-if="calculandoEmprestimo" type="input"></b-skeleton>
              <validation-provider
                v-else
                #default="{ errors }"
                name="Valor da Parcela"
                :rules="{
                  required: true,
                  valor: proposta.valorMaximoPrimeiraParcela,
                  valor_minimo: formatarParaNumber(parametroValorMinimoParcela),
                  zero: [],
                }"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <span class="input-group-text">R$</span>
                  </b-input-group-prepend>
                  <b-form-input
                    id="valorPrimeiraParcela"
                    :placeholder="
                      proposta.tipoCalculo == 'SAC'
                        ? 'Valor da 1º Parcela'
                        : proposta.tipoCalculo == 'posFixado'
                        ? 'Valor Previsto'
                        : 'Valor da Parcela'
                    "
                    v-model="proposta.valorPrimeiraParcela"
                    v-number="number"
                    :readonly="proposta.formaCalculo == 'valorDoEmprestimo'"
                  />
                </b-input-group>
                <small
                  class="text-primary d-block"
                  v-if="proposta.valorMaximoPrimeiraParcela != null || proposta.valorMaximoPrimeiraParcela != undefined"
                  >Valor Máx ({{ formatarValor(proposta.valorMaximoPrimeiraParcela) }})</small
                >
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" v-if="proposta.compraDeDivida">
            <b-form-group label="Valor da Dívida" label-for="valor">
              <validation-provider
                #default="{ errors }"
                name="Valor da Dívida"
                :rules="{
                  required: true,
                  zero: [],
                }"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <span class="input-group-text">R$</span>
                  </b-input-group-prepend>
                  <b-form-input id="valor" placeholder="Valor da Dívida" v-model="proposta.valorDaDivida" v-number="number" />
                </b-input-group>
                <small class="text-primary d-block" v-if="proposta.valor != null || proposta.valorDaDivida != undefined"
                  >Valor da Dívida ({{
                    formatarValor(
                      formatarParseFloat(proposta.valor ? proposta.valor : '0') -
                        formatarParseFloat(proposta.valorDaDivida ? proposta.valorDaDivida : '0'),
                    )
                  }})</small
                >
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="1º Parcela" label-for="primeiraParcela">
              <b-form-input
                id="primeiraParcela"
                class="form-control"
                type="text"
                placeholder="DD/MM/AAAA"
                v-model="proposta.primeiraParcela"
                :options="options.cleaveDate"
                :raw="false"
                :readonly="true"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="userData.Instituto.utilizaIOF" md="4">
            <b-form-group label="Valor do IOF" label-for="valorIOF">
              <b-skeleton v-if="calculandoParcela || calculandoEmprestimo" type="input"></b-skeleton>
              <b-input-group v-else>
                <b-input-group-prepend>
                  <span class="input-group-text">R$</span>
                </b-input-group-prepend>
                <b-form-input
                  id="valorIOF"
                  v-number="number"
                  placeholder="Valor do IOF"
                  v-model="proposta.valorIOF"
                  :readonly="true"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="8" v-if="proposta.compraDeDivida">
            <b-form-group label="Banco" label-for="dadoBancarioBanco">
              <validation-provider #default="{ errors }" name="Banco" rules="required">
                <v-select-pt
                  name="dadoBancarioBanco"
                  v-model="proposta.bancoId"
                  :options="banco"
                  :reduce="(option) => option.id"
                  label="nome"
                ></v-select-pt>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Valor Emprestado" label-for="valorTotal">
              <b-skeleton v-if="calculandoParcela || calculandoEmprestimo" type="input"></b-skeleton>
              <b-input-group v-else>
                <b-input-group-prepend>
                  <span class="input-group-text">R$</span>
                </b-input-group-prepend>
                <b-form-input
                  id="valorTotal"
                  v-number="number"
                  placeholder="Valor Emprestado"
                  v-model="proposta.valorTotal"
                  :readonly="true"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <!-- Tabela de Parcelas  -->
    <tab-content title="Tabela de Parcelas" :before-change="validationTabelaParcelas">
      <b-card-title v-if="origemAplicativo" title-tag="h3" class="font-weight-bold mb-2 mt-2">
        Tabela de Parcelas
      </b-card-title>

      <validation-observer ref="bankRules" tag="form">
        <b-form>
          <b-row>
            <b-table
              striped
              responsive
              foot-clone
              class="position-relative"
              :per-page="perPageParcelas"
              :current-page="currentPageParcelas"
              :items="itemsParcelas"
              :fields="fieldsParcelas"
              :sort-by.sync="sortByParcelas"
              :sort-desc.sync="sortDescParcelas"
              :sort-direction="sortDirectionParcelas"
              :busy="isBusy"
            >
              <template #cell(valor)="row">
                {{
                  proposta.tipoCalculo == 'posFixado'
                    ? formatarValor(row.item.valor) + ' + ' + userData.Instituto.tipoIndiceSelecionado
                    : formatarValor(row.item.valor)
                }}
              </template>

              <template #cell(vencimento)="row">
                {{ formatarData(row.item.vencimento) }}
              </template>

              <template #foot(parcela)>
                <span>Total: </span>
              </template>

              <template #foot(valor)>
                <span>{{ valorTotalParcelas ? valorTotalParcelas : 0.0 }}</span>
              </template>

              <template #foot(vencimento)>
                {{ '' }}
              </template>
            </b-table>

            <b-card-body class="d-flex justify-content-center flex-wrap pt-0">
              <b-pagination
                v-model="currentPageParcelas"
                :total-rows="totalRowsParcelas"
                :per-page="perPageParcelas"
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-card-body>
          </b-row>
        </b-form>
      </validation-observer>
    </tab-content>
  </form-wizard>
</template>
<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, valor, valor_minimo } from '@validations'
  import useJwt from '@/auth/jwt/useJwt'
  import Ripple from 'vue-ripple-directive'
  import { VueAutosuggest } from 'vue-autosuggest'
  import {
    isNumber,
    formatarValor,
    formatarData,
    formatarParseFloat,
    formatarToLocaleString,
    formatarDataWTime,
    formatarParaNumber,
    detectarNavegador,
    formatarValorReais,
    calcularIdade,
  } from '@/libs/utils'
  import Cleave from 'vue-cleave-component'
  import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Banco from '@core/components/banco/Banco.vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { parse } from 'date-fns'
  import * as math from 'mathjs'

  export default {
    components: {
      Banco,
      ValidationProvider,
      WizardButton,
      ValidationObserver,
      VueAutosuggest,
      Cleave,
      FormWizard,
      TabContent,
      formatarData,
      calcularIdade,
      formatarParaNumber,
    },
    directives: {
      Ripple,
    },
    props: {
      parametro: {
        origem: {
          type: String,
        },
        habilitaReconhecimentoFacialOuDocumentacao: {
          type: Boolean,
        },
      },
    },
    data() {
      return {
        textoBotaoFinalizar: 'Finalizar',
        dadosParaSalvar: {},
        origemAplicativo: false,
        isBusySegurado: false,
        formatarParaNumber,
        calculou: false,
        calculandoParcela: false,
        calculandoEmprestimo: false,
        parametroValorMinimoEmprestimo: 0,
        parametroValorMinimoParcela: 0,
        banco: [],
        formatarParseFloat: formatarParseFloat,
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        cadastroFinalizado: false,
        isBusy: false,
        loading: false,
        isNumber,
        formatarValor,
        formatarData,
        itemChange: false,
        number: {},
        proposta: {
          bancoId: undefined,
          status: 0,
          valorComIOF: 0,
          parcelaComIOF: 0,
          valorIOF: 0,
          taxaIOF: 0,
          compraDeDivida: false,
          valorDaDivida: 0,
          valorTotal: undefined,
          tipoCalculo: null,
        },
        segurado: { tomador: {} },
        suggestions: [],
        timeout: null,
        debounceMilliseconds: 300,
        required,
        valor_minimo,
        valor: 0,
        sortByParcelas: '',
        sortDescParcelas: false,
        sortDirectionParcelas: 'asc',
        perPageParcelas: 12,
        currentPageParcelas: 1,
        fieldsParcelas: ['parcela', 'valor', 'vencimento'],
        totalRowsParcelas: 0,
        itemsParcelas: [],
        valorTotalParcelas: 0,
        exibeDadosSegurado: false,
        vinculoOpcoesCalculo: false,
        cleaveCurrency: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          delimiter: '.',
          numeralDecimalMark: ',',
          numeralDecimalScale: 2,
        },
        options: {
          cleaveCPF: {
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
          },
          cleaveDate: {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
          },
        },
        statusTipoCalculo: [],
        optionsFormaCalculo: [
          { value: 'valorDoEmprestimo', text: 'Valor do Empréstimo' },
          { value: 'valorDaParcela', text: 'Valor da Parcela' },
        ],
        dados: [],
        pesquisar: {
          tipoOpcoes: 1,
          descricao: '',
          perPage: 10,
          currentPage: 1,
          statusOpcoes: '',
        },
        tipoOpcoes: [
          { value: 1, text: 'Nome' },
          { value: 2, text: 'CPF' },
          { value: 3, text: 'Matrícula' },
        ],
        statusOpcoes: [
          { value: '', text: 'Todos' },
          { value: 'GerouProposta', text: 'Gerou Proposta' },
          { value: 'Pendente', text: 'Pendente' },
          { value: 'Expirado', text: 'Expirado' },
        ],
        campoSeguradoSelecionado: true,

        // Permissões
        utilizaIOF: false,
        utilizaFloatFinanceiro: false,

        // Índices de Referência
        competenciaDaTaxa: null,
        taxaDaCompetencia: null,
      }
    },
    async created() {
      this.origemAplicativo = this.parametro.origem == 'Aplicativo' ? true : false
      if (this.origemAplicativo) this.preparaComponenteParaAplicativo()
    },
    async mounted() {
      this.proposta = {
        ...this.proposta,
        institutoSelecionado: this.userData.institutoSelecionado,
      }
      await this.buscarTipoDeCalculo()
      this.parametroValorMinimoEmprestimo = this.userData.Instituto.valorMinimoEmprestimo
      this.parametroValorMinimoParcela = this.userData.Instituto.valorMinimoParcela
      this.exibeDadosSegurado = false
      this.proposta.formaCalculo = 'valorDoEmprestimo'
      this.utilizaIOF = this.userData.Instituto.utilizaIOF
      this.utilizaFloatFinanceiro = this.userData.Instituto.utilizaFloatFinanceiro
      await this.carregarBancos()
      this.origemAplicativo = this.parametro.origem == 'Aplicativo' ? true : false
      this.textoBotaoFinalizar = this.parametro.habilitaReconhecimentoFacialOuDocumentacao
        ? 'Solicitar Contratação'
        : 'Enviar Solicitação'
    },
    methods: {
      retornarAbaInicial() {
        this.$emit('retornarAbaInicial')
      },
      habilitarBotaoProximoCalcular(aba) {
        if (aba === 2) {
          return this.calculou === true
        } else {
          return true
        }
      },
      findClosestValue(arr, target) {
        if (arr.length === 0) return null // Handle empty array case

        let closest = arr[0].parcelaReal
        let index = 0
        for (let i = 0; i < arr.length; i++) {
          if (Math.abs(target - arr[i].parcelaReal) < Math.abs(target - closest)) {
            closest = arr[i].parcelaReal
            index = i
          }
        }

        return arr[index]
      },
      async recalcular() {
        let iof, float

        if (this.utilizaIOF) {
          iof = await this.calcularIOF()
          this.proposta.valorComIOF = formatarValorReais(iof.valorComIOF)
          this.proposta.parcelaComIOF = formatarValorReais(iof.parcelaComIOF)
          this.proposta.valorPrimeiraParcela = formatarParaNumber(iof.parcelaComIOF)
          this.proposta.valorIOF = formatarValorReais(iof.valorIOF)
          this.proposta.taxaIOF = iof.taxaIOF
          this.proposta.quantidadeDiasIOF = iof.quantidadeDiasIOF
          this.proposta.valorBaseCalculo = iof.valorBaseCalculo
          this.proposta.valorDiarioIOF = iof.valorDiarioIOF
          this.proposta.valorEfetivoIOF = iof.valorEfetivoIOF
          this.proposta.taxaDiariaIOF = iof.taxaDiariaIOF
          this.proposta.taxaEfetivaIOF = iof.taxaEfetivaIOF
          this.proposta.valorTotalIOF = iof.valorTotalIOF
        }

        if (this.utilizaFloatFinanceiro) {
          float = await this.calcularFloat()
          this.proposta.valorComFloat = formatarValorReais(float.valorComFloat)
          this.proposta.valorPrimeiraParcela = formatarParaNumber(float.parcelaComFloat)
          this.proposta.valorDoFloat = formatarValorReais(float.valorDoFloat)
        }

        const { primeiraParcela } = await this.gerarParcelas()
        if (this.proposta.formaCalculo == 'valorDoEmprestimo') {
          let valorTotal = formatarParaNumber(this.proposta.valor)

          if (iof) valorTotal += iof.valorIOF
          if (float) valorTotal += float.valorFloat

          this.proposta.valorTotal = formatarValor(valorTotal)
          this.proposta.valorPrimeiraParcela = formatarValor(primeiraParcela)
        } else if (this.proposta.formaCalculo == 'valorDaParcela') {
          let valorDaProposta = formatarParaNumber(this.proposta.valor)

          valorDaProposta = valorDaProposta - iof.valorIOF
          valorDaProposta = valorDaProposta - float.valorFloat

          let valorTotal = formatarParaNumber(this.proposta.valor)
          if (iof) valorTotal += iof.valorIOF
          if (float) valorTotal += float.valorFloat

          this.proposta.valor = formatarValor(valorDaProposta)
          this.proposta.valorTotal = formatarValor(valorTotal)
        }
      },
      async carregarBancos() {
        await useJwt
          .get('utils/bancos')
          .then((response) => {
            this.banco = response.data
            this.banco.forEach((banco) => {
              if (banco.codigo) banco.nome = String(banco.codigo) + ' - ' + String(banco.nome)
            })
          })
          .catch((error) => {
            console.error(error)
          })
      },
      validarCalculoParcelas() {
        if (this.proposta.parcelas == undefined || !(this.proposta.parcelas > 0)) {
          this.$message.error('Preencha o número de parcelas.')
          return false
        } else if (this.proposta.valorPrimeiraParcela == undefined) {
          this.$message.error('Preencha o valor de parcela.')
          return false
        } else {
          return true
        }
      },
      async calcular(event) {
        if (this.proposta.formaCalculo == 'valorDaParcela') {
          if (!this.validarCalculoParcelas()) return
        }
        console.debug(' ====================  NOVO CÁLCULO ==================== ')

        this.calculou = true

        let parcelas = this.proposta.parcelas ?? 0
        let valorPrimeiraParcela = this.proposta.valorPrimeiraParcela
          ? formatarParaNumber(this.proposta.valorPrimeiraParcela)
          : 0.0
        let valor = this.proposta.valor ? formatarParaNumber(this.proposta.valor) : 0.0

        if (!(parcelas > 0 && (valor > 0 || valorPrimeiraParcela) > 0)) {
          return
        }
        if (this.proposta.formaCalculo == 'valorDoEmprestimo') {
          this.calculandoEmprestimo = true
        } else if (this.proposta.formaCalculo == 'valorDaParcela') {
          this.calculandoParcela = true
        }

        if (parcelas > 0 && (valor > 0 || valorPrimeiraParcela) > 0) {
          const response = await useJwt.post('utils/GetcalcularValoresSegurado', {
            idSegurado: this.segurado.id,
            institutoSelecionado: this.proposta.institutoSelecionado,
            valor: valor,
            parcelas: this.proposta.parcelas,
            valorPrimeiraParcela: valorPrimeiraParcela,
            campo: event.target.id,
            tipoCalculo: this.proposta.tipoCalculo,
            formaCalculo: this.proposta.formaCalculo,
          })
          if (response.data.status == 'erro' || response.data.status == 'atencao') this.$message.error(response.data.mensagem)
          else {
            this.proposta.valorPrimeiraParcela = response.data.valorPrimeiraParcela
            this.proposta.valorDoEmprestimo = this.formatarValorToText(response.data.valorDoEmprestimo)
            this.proposta.valorEfetivo = response.data.valor
            this.proposta.valorMaximoGeral = response.data.valorMaximoGeral
            this.proposta.taxa = Number(response.data.taxa)
            this.proposta.parcelaMaxima = response.data.parcelaMaxima
          }

          try {
            if (this.proposta.formaCalculo == 'valorDaParcela') {
              this.calculandoParcela = true
              const valorDaParcela = this.proposta.valorPrimeiraParcela

              const resposta = await useJwt.post('proposta/calcularProposta', {
                utilizaFloatFinanceiro: this.utilizaFloatFinanceiro,
                utilizaIOF: this.utilizaIOF,
                parcelas: Number(this.proposta.parcelas),
                primeiraParcela: parse(this.proposta.primeiraParcela, 'dd/MM/yyyy', new Date()).toISOString(),
                valorParcela: this.proposta.valorPrimeiraParcela,
                taxaEmprestimoMensal: Number(this.userData.Instituto.taxaEmprestimoMensal),
                mesVencimento: Number(this.userData.Instituto.mesVencimento),
                diaDeRepasse: Number(this.proposta.diaDeRepasse),
                diaFechamentoFolha: Number(this.proposta.diaFechamentoFolha),
              })

              await this.calcularValorMaisProximoParcela(resposta, valorDaParcela)

              return
            }
            await this.recalcular()
          } catch (e) {
            console.error(e)
          } finally {
            this.calculandoParcela = false
            this.calculandoEmprestimo = false
          }
        }
      },
      async calcularValorMaisProximoParcela(resposta, valorDaParcela) {
        const dados = this.findClosestValue(resposta.data, valorDaParcela)
        this.proposta.valorPrimeiraParcela = dados.parcelaReal
        this.proposta.valorBaseCalculo = dados.valor

        let iof = dados.iof
        let float = dados.float
        if (this.utilizaIOF) {
          this.proposta.valorComIOF = formatarValorReais(iof.valorComIOF)
          this.proposta.parcelaComIOF = formatarValorReais(iof.parcelaComIOF)
          this.proposta.valorIOF = formatarValorReais(iof.iofDiario + iof.iofEfetivo)
          this.proposta.taxaIOF = iof.taxaIOF
        }

        if (this.utilizaFloatFinanceiro) {
          this.proposta.valorComFloat = formatarValorReais(float.float + iof.valorComIOF)
          this.proposta.valorDoFloat = formatarValorReais(float.float)
        }

        const { primeiraParcela } = await this.gerarParcelas()
        this.proposta.valor = formatarValor(dados.valor)
        this.proposta.valorTotal = formatarValor(dados.valorTotal)
        this.proposta.valorPrimeiraParcela = formatarValor(dados.parcelaReal)
      },
      fetchResults() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (!this.proposta.segurado) {
            this.proposta = {
              ...this.proposta,
              seguradoSelecionado: null,
              segurado: null,
            }
            return
          }
          // let institutoId = this.userData.Instituto[0].id ?? this.proposta.institutoSelecionado;
          if (this.proposta.segurado.length >= 3) {
            useJwt
              .pesquisar('cadastro/tomador/GetSimulacaoPropostaSegurados', {
                descricao: this.proposta.segurado,
                institutoSelecionado: this.proposta.institutoSelecionado,
              })
              .then((response) => {
                this.suggestions = [{ data: response.data }]
              })
              .catch((error) => {
                console.error(error)
              })
          } else this.suggestions = []
        }, this.debounceMilliseconds)
      },
      async buscarTipoDeCalculo() {
        await useJwt
          .get(`cadastro/instituto/buscarTipoDeCalculo/${this.proposta.institutoSelecionado}`)
          .then((response) => {
            let opcoes = [{ value: null, text: 'Selecione:', disabled: true }] // Opção de placeholder
            let quantidadeDeOpcoes = 0

            if (response.data[0].tipoCalculoSAC == true) {
              opcoes.push({ id: 'tipoCalculoSac', value: 'sac', text: 'SAC' })

              quantidadeDeOpcoes++
            }
            if (response.data[0].tipoCalculoPrice == true) {
              opcoes.push({ id: 'tipoCalculoPrice', value: 'price', text: 'PRICE' })
              quantidadeDeOpcoes++
            }
            if (response.data[0].tipoCalculoPosFixado == true) {
              opcoes.push({ id: 'tipoCalculoPosFixado', value: 'posFixado', text: 'Pós Fixado' })
              quantidadeDeOpcoes++
            }

            if (quantidadeDeOpcoes == 1) {
              this.proposta.tipoCalculo = opcoes[1].value
            }
            this.statusTipoCalculo = opcoes
          })
          .catch((error) => {
            console.error(error)
          })
      },
      async GetPesquisarIdadeCriteriosElegibilidade(item) {
        const dados = {
          institutoId: this.userData.institutoSelecionado,
          categoria: this.segurado.categoria,
          idade: calcularIdade(item.tomador.dataNascimento),
        }
        await useJwt
          .post('cadastro/instituto/GetPesquisarIdadeCriteriosElegibilidade', dados)
          .then((response) => {
            this.idadePermitida = response.data?.length > 0 ? true : false
          })
          .catch((error) => {
            console.error(error)
          })
      },
      async getSuggestionValue(suggestion) {
        const { item } = suggestion
        this.isBusySegurado = true

        if (!item.grupoFolhaId) {
          this.proposta.segurado = ''
          this.suggestions = []

          this.$swal({
            title: 'Atenção!',
            text: 'O segurado não possui grupo folha cadastrado.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          this.isBusySegurado = false
          return
        }

        await this.GetPesquisarIdadeCriteriosElegibilidade(item)

        if (!this.idadePermitida) {
          this.proposta.segurado = ''
          this.suggestions = []
          this.$swal({
            title: 'Atenção!',
            text: 'O segurado não possui idade permitida para o empréstimo.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          this.isBusySegurado = false
          return
        }

        if (!item.grupoFolha.diaDeRepasse) {
          this.proposta.segurado = ''
          this.suggestions = []

          this.$swal({
            title: 'Atenção!',
            text: 'O grupo folha não possui dia de repasse cadastrado.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          this.isBusySegurado = false
          return
        }

        if (!this.segurado.tomador.dataNascimento) this.campoSeguradoSelecionado = false
        this.exibeDadosSegurado = true
        this.segurado.id = item.id
        this.segurado.tomador.cpf = item.tomador.cpf
        this.segurado.tomador.nomeCompleto = item.tomador.nomeCompleto
        this.segurado.tomador.nomeSocial = item.tomador.nomeSocial
        this.segurado.tomador.dataNascimento = formatarData(item.tomador.dataNascimento)
        this.segurado.categoria = item.situacaoPrevidenciaria
        this.segurado.remuneracaoProventos = formatarValor(item.remuneracao)
        this.segurado.margemUtilizada = formatarValor(item.margemUtilizada)
        this.segurado.margemDisponivel = formatarValor(item.margemDisponivel)
        this.proposta.seguradoSelecionado = item
        this.proposta.diaDeRepasse = item.grupoFolha.diaDeRepasse
        this.proposta.diaFechamentoFolha = item.grupoFolha.diaFechamentoFolha

        this.isBusySegurado = false

        return item.nomeCompleto
      },
      validationDadosSegurado() {
        return new Promise(async (resolve, reject) => {
          await this.$refs.tomRules.validate().then(async (success) => {
            if (success && this.segurado?.tomador?.nomeCompleto) {
              resolve(true)
            } else {
              let title
              if (!success) title = 'Alerta! Há campos não preenchidos no formulário.'
              else title = 'Alerta! Selecione o segurado na pesquisa para avançar.'
              this.msgError(title)
              reject()
            }
          })
        })
      },
      validationTipoCalculo() {
        return new Promise(async (resolve, reject) => {
          await this.$refs.tipRules.validate().then((success) => {
            if (success) {
              // let institutoId = this.userData.Instituto[0].id ?? this.proposta.institutoSelecionado;

              useJwt
                .post('utils/GetcalcularValoresSegurado', {
                  idSegurado: this.segurado.id,
                  institutoSelecionado: this.proposta.institutoSelecionado,
                  tipoCalculo: this.proposta.tipoCalculo,
                  formaCalculo: this.proposta.formaCalculo,
                })
                .then((response) => {
                  const values = { ...response.data, valor: undefined, valorPrimeiraParcela: undefined, parcelas: undefined }
                  this.proposta = {
                    ...this.proposta,
                    ...values,
                  }
                })
                .catch((error) => {
                  console.error(error)
                  this.$swal({
                    title: 'Atenção!',
                    text: 'Segurado não elegível para o empréstimo.',
                    icon: 'error',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                  })
                })
              this.proposta.valorPrimeiraParcela = undefined
              this.proposta.valor = undefined
              this.proposta.parcelas = undefined
              this.proposta.valorIOF = undefined
              this.proposta.valorTotal = undefined
              this.proposta.valorDaDivida = undefined
              this.proposta.bancoId = undefined
              this.$refs.dadosRules.reset()
              resolve(true)
            } else {
              let title = 'Alerta: Há campos não preenchidos no formulário.'
              this.msgError(title)
              reject()
            }
          })
        })
      },
      validationDadosConsignacao() {
        return new Promise(async (resolve, reject) => {
          await this.$refs.dadosRules.validate().then((success) => {
            if (success && this.proposta.valor && this.proposta.parcelas && this.proposta.valorPrimeiraParcela) {
              resolve(true)
            } else {
              let valorDigitado = this.proposta.valorPrimeiraParcela
              let valorMaximo = this.proposta.valorMaximoPrimeiraParcela
              let valorDigitadoFloat = parseFloat(valorDigitado?.replace(/\./g, '')?.replace(',', '.'))
              if (valorDigitadoFloat > valorMaximo) {
                let title = 'Alerta: O valor da parcela é maior que o permitido.'
                this.msgError(title)
                reject()
              } else if (!success && (!this.proposta.valorPrimeiraParcela || !this.proposta.valor || !this.proposta.parcelas)) {
                this.msgError('Erro: Há campos não preenchidos no formulário.')
                reject()
              } else if (
                !success &&
                formatarParaNumber(this.proposta.valor) < formatarParaNumber(this.parametroValorMinimoEmprestimo)
              ) {
                this.msgError('Exitem valores inferiores ao parâmetro mínimo.')
                reject()
              } else if (
                !success &&
                formatarParaNumber(this.proposta.valorPrimeiraParcela) < formatarParaNumber(this.parametroValorMinimoParcela)
              ) {
                this.msgError('Exitem valores inferiores ao parâmetro mínimo.')
                reject()
              } else if (!success && !this.proposta.valorDaDivida) {
                this.msgError('Campo valor da dívida é obrigatório.')
                reject()
              } else if (!success && !this.proposta.bancoId) {
                this.msgError('Campo banco é obrigatório.')
                reject()
              }
            }
          })
        })
      },
      validationDadosIOF() {
        return new Promise(async (resolve, reject) => {
          await this.$refs.dadosIofRules.validate().then((success) => {
            if (success) {
              this.proposta.valor = this.proposta.valorComIOF
              this.proposta.valorPrimeiraParcela = this.proposta.parcelaComIOF
              resolve(true)
              if (this.utilizaFloatFinanceiro) this.calcularFloat()
              this.gerarParcelas()
            } else {
              const emprestimoComIOF = formatarParaNumber(this.proposta.valorComIOF)
              const emprestimoMaximo = formatarParaNumber(this.proposta.valorMaximoGeral)
              const parcelaComIOF = formatarParaNumber(this.proposta.parcelaComIOF)
              const parcelaMaxima = formatarParaNumber(this.proposta.valorMaximoPrimeiraParcela)

              if (emprestimoComIOF > emprestimoMaximo) {
                this.$message.error('O valor do Empréstimo + IOF é maior que o permitido.')
                reject()
              }

              if (parcelaComIOF > parcelaMaxima) {
                this.$message.error('Valor da Parcela com IOF é maior que o permitido.')
                reject()
              }
            }
          })
        })
      },
      validationTabelaParcelas() {
        return new Promise(async (resolve, reject) => {
          await this.$refs.bankRules.validate().then((success) => {
            if (success) {
              resolve(true)
            } else {
              let title = 'Erro: Há campos não preenchidos no formulário.'
              this.msgError(title)
              reject()
            }
          })
        })
      },
      async gerarParcelas() {
        this.isBusy = true
        const saldoDevedor = this.utilizaIOF
          ? formatarParaNumber(this.proposta.valorComIOF)
          : formatarParaNumber(this.proposta.valor)

        const valorFloat = this.utilizaFloatFinanceiro ? formatarParaNumber(this.proposta.valorDoFloat) : 0

        // comment to commit
        const response = await useJwt.post('utils/GetcalcularParcelasSegurado', {
          idSegurado: this.proposta.seguradoSelecionado.id,
          institutoSelecionado: this.proposta.institutoSelecionado,
          parcelas: this.proposta.parcelas,
          taxa: this.proposta.taxa.toString(),
          saldoDevedor: saldoDevedor,
          valorFloat: valorFloat,
          valorDaParcela: formatarParaNumber(this.proposta.valorPrimeiraParcela),
          tipoCalculo: this.proposta.tipoCalculo,
          formaCalculo: this.proposta.formaCalculo,
        })

        if (response.data['status'] == 'atencao') {
          this.$message.error('Erro ao gerar parcelas!')
        }

        this.isBusy = false
        this.itemsParcelas = response.data

        for (let parcela of this.itemsParcelas) {
          if (parcela.taxaindiceInflacionarioPosFixado?.value) {
            parcela.taxaindiceInflacionarioPosFixado = parcela.taxaindiceInflacionarioPosFixado?.value
          }
          if (parcela.taxajurosAtuariaisPosFixado?.value) {
            parcela.taxajurosAtuariaisPosFixado = parcela.taxajurosAtuariaisPosFixado?.value
          }
          if (parcela.taxafundoGarantidorPosFixado?.value) {
            parcela.taxafundoGarantidorPosFixado = parcela.taxafundoGarantidorPosFixado?.value
          }
          if (parcela.taxataxaAdministrativaPosFixado?.value) {
            parcela.taxataxaAdministrativaPosFixado = parcela.taxataxaAdministrativaPosFixado?.value
          }

          parcela.valor = parcela.valor.toFixed(2)
        }

        let initialValue = 0
        this.valorTotalParcelas = this.itemsParcelas.reduce(
          (accumulator, currentValue) => Number(accumulator) + Number(currentValue.valor),
          initialValue,
        )
        this.valorTotalParcelas = formatarValor(formatarParaNumber(this.valorTotalParcelas).toFixed(2))
        this.totalRowsParcelas = response.data.length

        return {
          valorTotalParcelas: this.valorTotalParcelas,
          itemsParcelas: this.itemsParcelas,
          primeiraParcela: this?.itemsParcelas[0]?.valor,
        }
      },
      msgError(Title) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: Title,
              icon: 'BellIcon',
              variant: 'danger',
            },
          },
          {
            position: 'top-right',
            timeout: 8000,
          },
        )
      },
      msgSuccess(Title) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: Title,
              icon: 'UserCheckIcon',
              variant: 'success',
            },
          },
          {
            position: 'top-right',
            timeout: 8000,
          },
        )
      },
      async verificaSalvarProposta() {
        await this.preparaDadosParaSalvar()

        if (this.parametro.habilitaReconhecimentoFacialOuDocumentacao) {
          this.$emit('proximaModal', this.dadosParaSalvar)
        } else {
          this.salvarContratoExterno()
        }
      },
      async preparaDadosParaSalvar() {
        const proposta = this.proposta
        await this.buscaCompetenciaTaxa()
        let navegadorUtilizado = detectarNavegador()

        let dataToSave = {
          ...proposta,
          valor: formatarParaNumber(proposta.valor),
          valorPrimeiraParcela: this.itemsParcelas[0].valor,
          primeiraParcela: proposta.primeiraParcela.split('/').reverse().join('-'),
          taxa: Number(math.multiply(Number(proposta.taxa), 100)),
          taxaDaCompetencia: this.taxaDaCompetencia,
          competenciaDaTaxa: this.competenciaDaTaxa,
          parcelas: parseInt(proposta.parcelas),
          seguradoId: proposta.seguradoSelecionado.id,
          institutoId: proposta.institutoSelecionado,
          navegadorUtilizado: navegadorUtilizado,
          tipoDeCalculoUtilizado: proposta.tipoCalculo,
          indiceUtilizado: this.userData.Instituto.tipoIndiceSelecionado,
          itemsParcelas: this.itemsParcelas,
          origem: 'Aplicativo',
        }

        if (this.utilizaIOF) {
          dataToSave.valor = proposta.valorComIOF
        }

        if (this.utilizaFloatFinanceiro) {
          dataToSave.valor = proposta.valorComFloat
        }

        let { segurado, seguradoSelecionado, ...data } = { ...dataToSave }
        this.dadosParaSalvar = data
      },
      async salvarContratoExterno() {
        useJwt
          .post('proposta/geraContratoExterno', this.dadosParaSalvar)
          .then((response) => {
            if (response.data.status == 'erro') {
              console.error(response.data.mensagem)
              this.$swal({
                title: 'Atenção!',
                text: response.data.mensagem,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.loading = !this.loading
                  this.$emit('finalizaProposta')
                }
              })
              return
            }

            this.$emit('finalizaProposta')
            this.$swal({
              title: 'Atenção!',
              text: 'Proposta gerada com sucesso',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            }).then((result) => {
              this.loading = !this.loading
              this.$message.success('Proposta gerada com sucesso!')
            })
          })
          .catch((error) => {
            this.loading = false
            console.error(error)
            this.$message.error('Erro ao salvar a proposta!')
          })
      },
      async buscaCompetenciaTaxa() {
        return new Promise(async (resolve, reject) => {
          await useJwt
            .get(`configuracoes/indices/FindOne/${this.userData.Instituto.tipoIndiceSelecionado}`)
            .then((response) => {
              this.competenciaDaTaxa = response.data.competencia
              this.taxaDaCompetencia = response.data.taxa
              resolve()
            })
            .catch((error) => {
              console.error(error)
              this.$message.error('Houve um erro ao consultar a taxa da competência.')
              reject()
            })
        })
      },
      async calcularIOF() {
        let parametros = {
          ...this.proposta,
          valor: formatarParaNumber(this.proposta.valor),
          valorDoEmprestimo: formatarParaNumber(this.proposta.valor),
          taxaDiariaIOF: this.userData.Instituto.aliquotaDiariaIOF,
          taxaEfetivaIOF: this.userData.Instituto.aliquotaEfetivaIOF,
          taxaSpreadPosFixado: this.userData.Instituto.taxaSpreadPosFixado,
        }

        const response = await useJwt.post('proposta/GetCalcularIOF', parametros)
        console.debug('IOF: ', response.data)

        const calculoIOf = {
          valorComIOF: response.data.valorComIOF,
          parcelaComIOF: response.data.parcelaComIOF,
          valorIOF: response.data.valorIOF,
          taxaIOF: response.data.taxaIOF,

          quantidadeDiasIOF: response.data.quantidadeDias,
          valorBaseCalculo: response.data.valorBaseCalculo,
          valorDiarioIOF: response.data.valorDiarioIOF,
          valorEfetivoIOF: response.data.valorEfetivoIOF,
          taxaDiariaIOF: response.data.taxaDiariaIOF,
          taxaEfetivaIOF: response.data.taxaEfetivaIOF,
          valorTotalIOF: response.data.valorTotalIOF,
        }
        return calculoIOf
      },
      async calcularFloat() {
        let parametroFloat = {
          valor: this.utilizaIOF ? formatarParaNumber(this.proposta.valorComIOF) : formatarParaNumber(this.proposta.valor),
          parcelas: formatarParaNumber(this.proposta.parcelas),
          taxa: this.proposta.taxa,
          diaDeRepasse: this.proposta.diaDeRepasse,
          diaFechamentoFolha: this.proposta.diaFechamentoFolha,
          instituto: {
            tipoVencimentoParcela: this.userData.Instituto.tipoVencimentoParcela,
            diaFixoVencimentoParcela: this.userData.Instituto.diaFixoVencimentoParcela,
            mesVencimento: this.userData.Instituto.mesVencimento,
            taxaEmprestimoMensal: this.userData.Instituto.taxaEmprestimoMensal,
            taxaSpreadPosFixado: this.userData.Instituto.taxaSpreadPosFixado,
          },
          tipoCalculo: this.proposta.tipoCalculo,
          taxaSpreadPosFixado: this.userData.Instituto.taxaSpreadPosFixado,
        }

        const response = await useJwt.post('proposta/GetCalcularFloat', parametroFloat)
        console.debug('FLOAT: ', response.data)
        this.gerarParcelas()

        return {
          valorComFloat: response.data.valorComFloat,
          valorFloat: response.data.valorDoFloat,
          parcelaComFloat: response.data.parcelaComFloat,
        }
      },
      formatarValorToText(valor) {
        let valorString = String(valor)
        if (!valorString.includes('.')) {
          valorString = valorString + '.00'
        }
        return valorString
      },
      preparaComponenteParaAplicativo() {
        this.proposta = {}
        let nomeTomador = String(this.userData.nomeCompleto).trim()

        // Consulta dados do tomador logado
        useJwt
          .pesquisar('cadastro/tomador/GetSimulacaoPropostaSegurados', {
            descricao: nomeTomador,
            institutoSelecionado: this.userData.institutoSelecionado,
          })
          .then((response) => {
            this.segurado.id = response.data[0].id
            this.segurado.tomador.cpf = response.data[0].tomador.cpf
            this.segurado.tomador.nomeCompleto = response.data[0].tomador.nomeCompleto
            this.segurado.tomador.nomeSocial = response.data[0].tomador.nomeSocial
            this.segurado.tomador.dataNascimento = formatarData(response.data[0].tomador.dataNascimento)
            this.segurado.categoria = response.data[0].situacaoPrevidenciaria
            this.segurado.remuneracaoProventos = formatarValor(response.data[0].remuneracao)
            this.segurado.margemUtilizada = formatarValor(response.data[0].margemUtilizada)
            this.segurado.margemDisponivel = formatarValor(response.data[0].margemDisponivel)
            this.proposta.seguradoSelecionado = response.data[0]
            this.proposta.diaDeRepasse = response.data[0].grupoFolha.diaDeRepasse
            this.proposta.diaFechamentoFolha = response.data[0].grupoFolha.diaFechamentoFolha
          })
          .catch((error) => {
            console.error(error)
          })
      },
    },
    watch: {
      'proposta.tipoCalculo'(valor) {
        if (valor == 'posFixado') {
          this.optionsFormaCalculo = [{ text: 'Valor do Empréstimo', value: 'valorDoEmprestimo' }]
          this.proposta.formaCalculo = 'valorDoEmprestimo'
        } else {
          this.optionsFormaCalculo = [
            { text: 'Valor do Empréstimo', value: 'valorDoEmprestimo' },
            { text: 'Valor da Parcela', value: 'valorDaParcela' },
          ]
        }
      },
    },
  }
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-autosuggest.scss';
  @import '@core/scss/vue/libs/vue-select.scss';

  pre {
    min-height: 295px;
    padding: 1.5rem;
    margin-bottom: 0;
    border-radius: 0.5rem;
  }

  .autosuggest__results-item {
    cursor: pointer;
  }

  #radiosFormasDeCalculo,
  #radiosTipoDeCalculo {
    display: flex;
  }

  #radiosFormasDeCalculo label span {
    white-space: nowrap;
  }

  // #botaoWizardVoltar,
  // #containerWizardVoltar {
  //   width: 100%;
  //   margin-bottom: 10px;
  // }

  // #botaoWizardCalcular,
  // .botaoWizardProxima {
  //   width: 100%;
  //   margin-bottom: 10px;
  // }

  // #rowWizard > div > button {
  //   margin-bottom: 15px;
  // }

  // #rowWizard {
  //   width: 100% !important;
  // }

  div.wizard-navigation > div.wizard-progress-with-circle,
  div.wizard-navigation > ul[role='tablist'] {
    display: none;
  }

  // Style do chat
  .wizard-footer .wizard-footer-btn {
    width: 50vw !important;
    min-width: 15vw !important;
    margin: 5px 0 !important;
  }

  .wizard-footer-col {
    padding: 5px !important;
  }

  .wizard-footer .wizard-footer-btn {
    padding: 12px 0 !important;
    box-shadow: none !important;
  }
  .wizard-footer .wizard-footer-col {
    padding: 3px !important;
  }
  .wizard-footer button {
    height: 40px !important;
    font-size: 14px !important;
    border-radius: 17px !important;
  }
</style>
